<template>
  <div class="ta-app" :class="mainConfig.overlayFilters ? 'ta-overlay-filters' : ''">
    <error-page-component v-if="error.code" />
    <template v-else>
      <ata-msg-modal/>
      <lot-inquiry-modal/>
      <ata-toast/>
      <terms-and-conditions-modal />
      <bid-created-modal/>
      <max-bid-created-modal/>
      <lot-purchased-modal/>
      <router-view class="ta-app-router-view"/>
    </template>
  </div>
</template>

<script>
import AtaToast from "./components/bootstrap/AtaToast";
import AtaMsgModal from "./components/bootstrap/AtaMsgModal";
import {mapGetters, mapActions, mapMutations, mapState} from "vuex";
import {checkOnlineStatus} from "./helpers";
import TermsAndConditionsModal from "@/components/configuration/signup/TermsAndConditionsModal.vue";
import LotInquiryModal from "@/components/lots-modals/LotInquiryModal.vue";
import BidCreatedModal from "@/components/BidCreatedModal.vue";
import MaxBidCreatedModal from "@/components/MaxBidCreatedModal.vue";
import LotPurchasedModal from "@/components/LotPurchasedModal.vue";
import ErrorPageComponent from "@/components/core/ErrorPageComponent.vue";

export default {
  components: {
    TermsAndConditionsModal,
    ErrorPageComponent,
    LotPurchasedModal,
    BidCreatedModal,
    MaxBidCreatedModal,
    AtaToast,
    AtaMsgModal,
    LotInquiryModal
  },

  data: () => ({
    onlineStatusInterval: null,
  }),

  methods: {
    ...mapMutations(['mutateIsAuthorized', 'setIsOnline']),
    ...mapActions(['sendSocketLogin', 'getCustomerMeta', 'socketLoginCallback']),
    async checkAndSetOnlineStatus() {
      this.setIsOnline(await checkOnlineStatus());
    }
  },

  computed: {
    ...mapGetters(['is_authorized']),
    ...mapState(['user', 'mainConfig', 'error'])
  },

  async mounted() {
    // this.mutateIsAuthorized(Boolean(this.$cookie.get(CONFIG.artisioCookieName)));
    // this.getCustomerMeta();

    await this.checkAndSetOnlineStatus();
    this.onlineStatusInterval = setInterval(this.checkAndSetOnlineStatus, 5000)
  },
  destroyed() {
    clearInterval(this.onlineStatusInterval);
  }
}
</script>

<style lang="scss">
#artisioTimedAuctions {
  &,
  .ta-app,
  .ta-app-router-view {
    height: 100%;
  }
}

//#artisioTimedAuctions {
//  padding: 20px;
//}
//#artisioTimedAuctions hr {
//  border-top: 1px solid rgba(130, 130, 130, 0.1) !important;
//}
</style>
